var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { axiosPrivate } from "../../api/axios";
// Function to update customer info via PUT request.
export const updateCustomerInfo = (key, { arg }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axiosPrivate.put("/Account/CustomerInfo", arg);
    if (!response.data.success) {
        throw new Error(response.data.message || "Failed to update customer info");
    }
    return response.data;
});
// Process update customer error from axios and return a more user-friendly error message.
export const processError = (error) => {
    var _a;
    let message = "Something unexpected happened while updating your information.";
    if (axios.isAxiosError(error)) {
        const errorResponse = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.Message) {
            message = errorResponse.Message;
        }
        if (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.ModelErrors) {
            const { Password, CurrentPassword, Email } = errorResponse.ModelErrors;
            const updateCustomerErrors = {};
            if (Password) {
                updateCustomerErrors.newPasswordErrors = Password;
            }
            if (CurrentPassword) {
                updateCustomerErrors.currentPasswordErrors = CurrentPassword;
            }
            if (Email) {
                updateCustomerErrors.emailErrors = Email;
            }
        }
        else if (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.Errors) {
            // Additional error messages
            message += ". " + errorResponse.Errors.join(". ");
        }
    }
    return new Error(message);
};
